module.exports = __webpack_public_path__ + "img/O&M.45b26f04.png";